<template>
    <div class="row-gap row-gap-10-px">
        <div v-if="[14].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">申請内容選択</div>
                <div class="item-group">
                    <ans-select
                        id="detailClass"
                        input-class="custom-border"
                        :options="options.detailClasses"
                        v-model="data.detailClass"
                        :isDisabled="disabled"
                        remove-empty-option
                    />
                </div>
            </div>
        </div>

        <div v-if="[16].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">申請内容入力</div>
                <div class="item-group">
                    <ans-input
                        id="content_input"
                        itemClass="text-center"
                        input-class="custom-border"
                        v-model="data.ShinseiDetail"
                        :isDisabled="disabled"
                        :isEnableIME="true"
                        :maxLength="200"
                    />
                </div>
            </div>
        </div>

        <div v-if="[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 13, 14, 16].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">申請日</div>
                <div class="item-group">
                    <ans-date-picker
                        id="application_date"
                        item-class=""
                        v-model="data.application_date"
                        input-class="custom-border"
                        :isDisabled="disabled"
                    />
                </div>
            </div>
        </div>

        <div v-if="[1, 3, 4, 7].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">出勤時間</div>
                <div class="item-group">
                    <ans-date-time
                        id="time_in"
                        v-model="data.time_in"
                        :isTimer="true"
                        :showIcon="false"
                        :isRequired="false"
                        :isDisabled="disabled"
                        input-class="custom-border"
                    />
                </div>
            </div>
        </div>

        <div v-if="[2, 3, 5, 7].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">退勤時間</div>
                <div class="item-group">
                    <ans-date-time
                        id="time_out"
                        v-model="data.time_out"
                        :isTimer="true"
                        :showIcon="false"
                        :isRequired="false"
                        :isDisabled="disabled"
                        input-class="custom-border"
                    />
                </div>
            </div>
        </div>

        <div v-if="[9].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">対象申請No</div>
                <div class="item-group">
                    <ans-input
                        id="target_no"
                        itemClass="text-center"
                        input-class="custom-border"
                        :isDisabled="disabled"
                        :isEnableIME="true"
                        v-model="data.target_no"
                        type="number"
                        :maxLength="8"
                    />
                </div>
            </div>
        </div>

        <div v-if="[14, 15].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">開始日</div>
                <div class="item-group">
                    <ans-date-picker id="start_date" item-class="" v-model="data.start_date" input-class="custom-border" :isDisabled="disabled" />
                </div>
            </div>
        </div>

        <div v-if="[14, 15].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">終了日</div>
                <div class="item-group">
                    <ans-date-picker id="end_date" item-class="" v-model="data.end_date" input-class="custom-border" :isDisabled="disabled" />
                </div>
            </div>
        </div>

        <div v-if="[6, 8, 9].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">開始時間</div>
                <div class="item-group">
                    <ans-date-time
                        id="start_time"
                        v-model="data.start_time"
                        :isTimer="true"
                        :showIcon="false"
                        :isRequired="false"
                        :isDisabled="disabled"
                        input-class="custom-border"
                    />
                </div>
            </div>
        </div>

        <div v-if="[6, 8, 9].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">終了時間</div>
                <div class="item-group">
                    <ans-date-time
                        id="end_time"
                        v-model="data.end_time"
                        :isTimer="true"
                        :showIcon="false"
                        :isRequired="false"
                        :isDisabled="disabled"
                        input-class="custom-border"
                    />
                </div>
            </div>
        </div>

        <div v-if="[1, 2, 3, 5, 6].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">理由選択</div>
                <div class="item-group">
                    <ans-select
                        id="reason_select"
                        input-class="custom-border"
                        :options="options.reasonClasses"
                        v-model="data.reasonClass"
                        :isDisabled="disabled"
                    />
                </div>
            </div>
        </div>

        <div v-if="[4, 7, 8, 9, 10, 12, 13, 14, 15].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">理由入力</div>
                <div class="item-group">
                    <ans-input
                        id="reason_input"
                        itemClass="text-center"
                        input-class="custom-border"
                        v-model="data.reason"
                        :isDisabled="disabled"
                        :isEnableIME="true"
                        :maxLength="200"
                    />
                </div>
            </div>
        </div>

        <div v-if="[1, 2, 3, 4, 5, 6].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">内容</div>
                <div class="item-group">
                    <ans-input
                        id="content_text"
                        itemClass="text-center"
                        input-class="custom-border"
                        v-model="data.content"
                        :isDisabled="disabled"
                        :isEnableIME="true"
                        :maxLength="200"
                    />
                </div>
            </div>
        </div>

        <div v-if="[16].includes(typeCode)" class="line col-md-8">
            <div class="field-item">
                <div class="lable_item">金額</div>
                <div class="item-group">
                    <ans-input
                        id="money"
                        type="money"
                        itemClass="text-center"
                        input-class="custom-border"
                        v-model="data.money"
                        :isDisabled="disabled"
                        :isEnableIME="true"
                        :maxLength="6"
                    />
                </div>
            </div>
        </div>

        <div v-if="[16].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">詳細</div>
                <div class="item-group">
                    <ans-input
                        id="detail"
                        itemClass="text-center"
                        input-class="custom-border"
                        v-model="data.detail"
                        :isDisabled="disabled"
                        :isEnableIME="true"
                        :maxLength="200"
                    />
                </div>
            </div>
        </div>
        <div v-if="[7, 16].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">ファイル</div>
                <div class="item-group">
                    <div class="list-file">
                        <div class="file-item" v-for="fileItem in displayFileList" :key="`author-app-file-${fileItem.slot_index}`">
                            <input
                                type="file"
                                class="d-none"
                                :id="`reporting_file_${fileItem.slot_index}`"
                                accept="application/pdf,image/*"
                                @change="(event) => changeFile(event, fileItem.slot_index)"
                            />
                            <span v-if="!disabled" class="file-icon" @click="openFile(fileItem.slot_index)">
                                <i class="fa-solid fa-folder"></i>
                            </span>
                            <span
                                class="file-name text-primary"
                                :class="{ 'cursor-pointer text-decoration-underline': canDownloadFile(fileItem) }"
                                @click="downloadFile(fileItem)"
                            >
                                {{ fileItem.name }}
                            </span>
                            <span v-show="fileItem.name && !disabled" class="text-danger cursor-pointer" @click="deleteFile(fileItem.slot_index)">
                                <i class="fa fa-trash"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="[11].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="lable_item">カレンダー対象月</div>
                <div class="item-group">
                    <ans-date-picker
                        id="target_month"
                        item-class=""
                        isMonthYear
                        v-model="data.target_month"
                        input-class="custom-border"
                        :isDisabled="disabled"
                        :on-change-event="changeMonthInput"
                    />
                </div>
            </div>
        </div>

        <div v-if="[11].includes(typeCode)" class="line">
            <div class="field-item">
                <div class="item-group">
                    <ans-calendar-selected-date
                        :initial-date="currentDate"
                        :selected-dates="selectedDates"
                        title-format="YYYY/MM"
                        calendar-width="280px"
                        selected-color="#ff0000"
                        :readonly="disabled"
                        @update:selectedDates="handleDateSelection"
                        @month-change="handleMonthChange"
                        :footer-config="{ show: disabled ? false : true }"
                    />
                </div>
            </div>
        </div>

        <div v-if="[11].includes(typeCode)" class="line line-date">
            <div class="field-item date-input" v-for="date in selectedDates" :key="date">
                {{ formatDate(date) }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import store from '@/store';
import DetailStore from './store';
import ansCalendarSelectedDate from '@/components/ansCalendarSelectedDate/index.vue';
import helpers from '@/utils/helpers';
import messages, { MSG_BUTTON, MSG_TITLE, MSG_TYPE } from '@/utils/messages';

export default {
    name: 'template_mode',
    components: {
        ansCalendarSelectedDate
    },
    props: {
        typeNo: [String, Number],
        application: {
            type: Object,
            default: () => null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    beforeCreate() {
        if (!store.hasModule('DetailStore')) {
            store.registerModule('DetailStore', DetailStore);
        }
    },
    watch: {
        typeNo() {
            this.selectedDates = [];
            if (this.typeCode !== 11) {
                this.setData(buildDayFlagsFromDates([]));
            }
            this.syncFromApplication();
        },
        application: {
            deep: true,
            immediate: true,
            handler() {
                this.loadReasonClasses();
                this.syncFromApplication();
                if (this.disabled) {
                    const res = this.convertApplication();
                    this.setData(res);
                }
            }
        }
    },
    data() {
        return {
            currentDate: new Date(),
            selectedDates: [],
            lastReasonClassRequestKey: ''
        };
    },
    computed: {
        ...mapState('DetailStore', ['data', 'options']),
        typeCode() {
            return parseInt(this.typeNo, 10) || 0;
        },
        displayFileList() {
            const slots = normalizeFileSlots(this.data.file_list);
            const visible = slots
                .map((item, slotIndex) => ({
                    ...item,
                    slot_index: slotIndex
                }))
                .filter((item) => hasDisplayFileValue(item));

            if (this.disabled) {
                return visible;
            }

            if (visible.length < 5) {
                const emptySlotIndex = slots.findIndex((item) => !hasDisplayFileValue(item));
                if (emptySlotIndex >= 0) {
                    visible.push({
                        ...slots[emptySlotIndex],
                        slot_index: emptySlotIndex
                    });
                }
            }

            return visible.sort((a, b) => a.slot_index - b.slot_index);
        }
    },
    methods: {
        ...mapMutations('DetailStore', ['setData', 'setOptions']),
        ...mapMutations('app', ['showModalMessage']),
        convertApplication() {
            const formatDate = (dateStr) => {
                if (!dateStr) return '';
                const d = new Date(dateStr);
                const yyyy = d.getFullYear();
                const mm = String(d.getMonth() + 1).padStart(2, '0');
                const dd = String(d.getDate()).padStart(2, '0');
                return `${yyyy}/${mm}/${dd}`;
            };

            const toNumberOrZero = (val) => (val ? Number(val) : 0);
            const src = this.application || {};
            const arrivalTime = toTime(getValue(src, ['arrival_time', 'ArrivalTime', 'start_time', 'StartTime']));
            const departureTime = toTime(getValue(src, ['departure_time', 'DepartureTime', 'departureTime', 'end_time', 'EndTime']));
            const fileList = buildFileListFromApplication(src);

            return {
                company_cd: src.CompanyCD,
                md_cd: src.MDCD,
                application_no: src.ShinseiNo,
                typeNo: src.Type,

                start_date: formatDate(src.StartDate) || '',
                end_date: formatDate(src.EndDate) || '',

                start_time: arrivalTime,
                end_time: departureTime,
                time_in: arrivalTime,
                time_out: departureTime,

                target_no: src.TargetNo || '',
                reasonClass: src.ReasonClass || '',
                reason: src.Reason || '',

                content: src.Content,
                detailClass: getValue(src, ['detail_class', 'detailClass', 'DetailClass']) || '',
                ShinseiDetail: src.DetailInput,
                money: src.Amount,
                detail: src.Detail,

                file_list: fileList,

                status_code: src.Status,

                application_date: formatDate(src.ApplicationDate),

                reason_class: src.ReasonClass,
                shinsei_detail: src.DetailInput,
                amount: src.Amount,

                attachment01: src.Attachments,
                target_month: src.TargetMonth ? src.TargetMonth.replace(/^(\d{4})(\d{2})$/, '$1/$2') : '',

                // map D1 → D31
                ...Object.fromEntries(
                    Array.from({ length: 31 }, (_, i) => {
                        const key = `D${i + 1}`;
                        return [`d${i + 1}`, toNumberOrZero(src[key])];
                    })
                )
            };
        },
        async loadReasonClasses() {
            try {
                const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
                const companyCd = String(
                    getValue(this.application, ['company_cd', 'CompanyCD']) || userInfo?.company_cd || this.$store.state.app?.user?.company_cd || ''
                ).trim();
                if (!companyCd) {
                    this.lastReasonClassRequestKey = '';
                    this.setOptions({ reasonClasses: [], detailClasses: [] });
                    return;
                }
                const requestKey = `41::42::${companyCd}`;
                if (this.lastReasonClassRequestKey === requestKey) {
                    return;
                }
                this.lastReasonClassRequestKey = requestKey;
                const [reasonResult, detailResult] = await Promise.all([
                    helpers.getDataSys005({ meisho_cd: 41, company_cd: companyCd }),
                    helpers.getDataSys005({ meisho_cd: 70, company_cd: companyCd })
                ]);
                const reasonClasses = (reasonResult || []).map((item) => ({
                    code: Number(item.code ?? 0),
                    name: item.name ?? ''
                }));
                const detailClasses = (detailResult || []).map((item) => ({
                    code: Number(item.code ?? 0),
                    name: item.name ?? ''
                }));
                this.setOptions({ reasonClasses, detailClasses });
            } catch (e) {
                this.lastReasonClassRequestKey = '';
                console.log('loadReasonClasses: ' + e.message);
            }
        },
        syncFromApplication() {
            if (!this.application || Object.keys(this.application).length === 0) return;

            const month = resolveMonth(this.application);
            const arrivalTime = toTime(getValue(this.application, ['arrival_time', 'ArrivalTime', 'start_time', 'StartTime']));
            const departureTime = toTime(getValue(this.application, ['departure_time', 'DepartureTime', 'departureTime', 'end_time', 'EndTime']));
            const fileList = buildFileListFromApplication(this.application);
            const mapped = {
                target_no: getValue(this.application, ['target_no', 'TargetNo']) || '',
                application_date: toDate(getValue(this.application, ['application_date', 'ApplicationDate', 'date'])),
                start_date: toDate(getValue(this.application, ['start_date', 'StartDate'])),
                end_date: toDate(getValue(this.application, ['end_date', 'EndDate'])),
                start_time: arrivalTime,
                end_time: departureTime,
                time_in: arrivalTime,
                time_out: departureTime,
                reasonClass: getValue(this.application, ['reason_class', 'ReasonClass']) || '',
                reason: getValue(this.application, ['reason', 'Reason']) || '',
                content: getValue(this.application, ['content', 'Content']) ?? '',
                detailClass: getValue(this.application, ['detail_class', 'detailClass', 'DetailClass']) || '',
                ShinseiDetail: getValue(this.application, ['ShinseiDetail', 'shinsei_detail']) || '',
                money: getValue(this.application, ['amount', 'Amount']) ?? '',
                detail: getValue(this.application, ['detail', 'Detail']) ?? getValue(this.application, ['DetailInput', 'detail_input']) ?? '',
                target_month: month,
                file_list: fileList
            };

            this.setData(mapped);

            const loadedDates = this.typeCode === 11 ? getSelectedDatesFromApplication(this.application, month) : [];
            if (month) {
                this.currentDate = parseMonthToDate(month);
            }

            if (this.typeCode === 11) {
                // ansCalendarSelectedDate clears selection when initialDate changes,
                // so re-apply loaded dates in next tick.
                this.$nextTick(() => {
                    this.selectedDates = [...loadedDates];
                    this.setData(buildDayFlagsFromDates(loadedDates));
                });
            } else {
                this.selectedDates = [];
            }
        },
        handleDateSelection(dates) {
            this.selectedDates = dates;
            this.selectedDates.sort((a, b) => new Date(a) - new Date(b));
            this.setData(buildDayFlagsFromDates(this.selectedDates));
        },
        handleMonthChange({ year, month }) {
            this.data.target_month = normalizeMonthDisplay(`${year}/${month}`);
            this.selectedDates = [];
            this.setData(buildDayFlagsFromDates([]));
        },
        changeMonthInput(newMonth) {
            const monthText = normalizeMonthDisplay(newMonth);
            this.data.target_month = monthText;
            this.currentDate = parseMonthToDate(monthText);
            this.selectedDates = [];
            this.setData(buildDayFlagsFromDates([]));
        },
        changeFile(event, index) {
            const file = event?.target?.files?.[0];
            if (!file) return;
            if (helpers.checkOverMaxFileSize(file)) {
                const input = document.querySelector(`#reporting_file_${index}`);
                if (input) input.value = '';
                return;
            }
            if (file.name.length > 200) {
                const input = document.querySelector(`#reporting_file_${index}`);
                if (input) input.value = '';
                this.showModalMessage({
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E001,
                    content: messages.E007,
                    cancelText: MSG_BUTTON.cancelText,
                    okText: MSG_BUTTON.okText
                });
                return;
            }
            const list = normalizeFileSlots(this.data.file_list);
            const current = list[index] || createFileItem();
            list[index] = {
                ...current,
                name: file.name,
                path: '',
                file
            };
            this.setData({ file_list: list });
        },
        deleteFile(index) {
            const list = compactFileSlotsAfterDelete(this.data.file_list, index);
            this.setData({ file_list: list });
            const input = document.querySelector(`#reporting_file_${index}`);
            if (input) input.value = '';
        },
        canDownloadFile(fileItem) {
            return !!fileItem?.path && !(fileItem?.file instanceof File);
        },
        downloadFile(fileItem) {
            if (!this.canDownloadFile(fileItem)) return;
            const fileName = fileItem?.path || '';
            if (!fileName) return;
            const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
            const companyCd = String(
                getValue(this.application, ['company_cd', 'CompanyCD']) || userInfo?.company_cd || this.$store.state.app?.user?.company_cd || ''
            ).trim();
            if (!companyCd) return;
            helpers.getFileToDownloadSys004({
                fileName,
                status: 14,
                company_cd: companyCd
            });
        },
        openFile(index) {
            const input = document.querySelector(`#reporting_file_${index}`);
            if (!input) return;
            input.value = '';
            input.click();
        },
        formatDate(dateStr) {
            const date = new Date(dateStr);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}/${month}/${day}`;
        }
    }
};

function getValue(obj, keys) {
    for (const key of keys) {
        if (obj?.[key] !== undefined && obj?.[key] !== null && obj?.[key] !== '') {
            return obj[key];
        }
    }
    return '';
}

function toDate(value) {
    if (!value) return '';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return `${value}`.substring(0, 10).replace(/-/g, '/');
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}/${m}/${d}`;
}

function toTime(value) {
    if (value === null || value === undefined || value === '' || `${value}` === '0') return '';
    const raw = `${value}`.replace(/\D/g, '');
    if (!raw) return '';
    const padded = raw.padStart(4, '0');
    return `${padded.slice(0, 2)}:${padded.slice(2, 4)}`;
}

function toMonth(value, baseDateValue = '') {
    if (!value || `${value}` === '0') return '';
    const raw = `${value}`.replace(/\D/g, '');
    if (raw.length >= 6) return `${raw.slice(0, 4)}/${raw.slice(4, 6)}`;
    if (raw.length <= 2) {
        const month = Number(raw);
        if (month >= 1 && month <= 12) {
            const year = resolveYear(baseDateValue);
            return `${year}/${String(month).padStart(2, '0')}`;
        }
    }
    return '';
}

function resolveMonth(application) {
    const fromTarget = toMonth(
        getValue(application, ['target_month', 'TargetMonth', 'month']),
        getValue(application, ['application_date', 'ApplicationDate', 'date'])
    );
    if (fromTarget) return fromTarget;

    if (!hasAnyDayFlag(application)) return '';

    const dateValue = getValue(application, ['application_date', 'ApplicationDate', 'date']);
    if (!dateValue) return '';
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return '';
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    return `${y}/${m}`;
}

function getSelectedDatesFromApplication(application, month) {
    if (!month) return [];
    const [year, monthNo] = month.split('/').map((v) => Number(v));
    if (!year || !monthNo) return [];

    const selected = [];
    for (let day = 1; day <= 31; day++) {
        const value = Number(getValue(application, [`D${day}`, `d${day}`]));
        if (value > 0) {
            const date = new Date(year, monthNo - 1, day);
            // Guard invalid dates (e.g. 2/30)
            if (date.getFullYear() === year && date.getMonth() === monthNo - 1 && date.getDate() === day) {
                selected.push(date);
            }
        }
    }
    return selected;
}

function extractFileName(path) {
    if (!path) return '';
    const parts = `${path}`.split(/[\\/]+/);
    return parts[parts.length - 1] ?? '';
}

function createFileItem(path = '') {
    return {
        name: extractFileName(path),
        path,
        old_path: path,
        file: null
    };
}

function hasDisplayFileValue(item) {
    return !!(item?.name || item?.path || item?.file);
}

function normalizeFileSlots(list = []) {
    return Array.from({ length: 5 }, (_, index) => {
        const item = list?.[index] || {};
        const path = item?.path || '';
        const oldPath = item?.old_path !== undefined ? item.old_path || '' : path;
        return {
            name: item?.name !== undefined ? item.name || '' : extractFileName(path || oldPath),
            path,
            old_path: oldPath,
            file: item?.file ?? null
        };
    });
}

function buildFileListFromApplication(application) {
    const paths = Array.from({ length: 5 }, (_, index) => getValue(application, [`attachment0${index + 1}`, `Attachment0${index + 1}`]) || '');
    return normalizeFileSlots(paths.map((path) => createFileItem(path)));
}

function compactFileSlotsAfterDelete(list = [], deleteIndex = -1) {
    const slots = normalizeFileSlots(list);
    const occupied = [];
    const cleanupPaths = [];

    slots.forEach((item, index) => {
        if (index === deleteIndex) {
            if (item?.old_path) {
                cleanupPaths.push(item.old_path);
            }
            return;
        }

        if (hasDisplayFileValue(item)) {
            occupied.push({
                ...item
            });
            return;
        }

        if (item?.old_path) {
            cleanupPaths.push(item.old_path);
        }
    });

    const referencedPaths = new Set();
    occupied.forEach((item) => {
        if (item?.path) referencedPaths.add(item.path);
        if (item?.old_path) referencedPaths.add(item.old_path);
    });

    const cleanupOnlyItems = Array.from(new Set(cleanupPaths.filter((path) => path && !referencedPaths.has(path)))).map((path) => ({
        name: '',
        path: '',
        old_path: path,
        file: null
    }));

    const result = [...occupied, ...cleanupOnlyItems].slice(0, 5);
    while (result.length < 5) {
        result.push(createFileItem());
    }

    return result;
}

function buildDayFlagsFromDates(dates) {
    const result = {};
    for (let day = 1; day <= 31; day++) {
        result[`d${day}`] = 0;
    }
    (dates || []).forEach((dateValue) => {
        const date = new Date(dateValue);
        if (Number.isNaN(date.getTime())) return;
        const day = date.getDate();
        if (day >= 1 && day <= 31) {
            result[`d${day}`] = 1;
        }
    });
    return result;
}

function hasAnyDayFlag(application) {
    for (let day = 1; day <= 31; day++) {
        if (Number(getValue(application, [`D${day}`, `d${day}`])) > 0) {
            return true;
        }
    }
    return false;
}

function resolveYear(value) {
    const date = value ? new Date(value) : new Date();
    if (Number.isNaN(date.getTime())) return new Date().getFullYear();
    return date.getFullYear();
}

function normalizeMonthDisplay(value) {
    if (!value) return '';
    const raw = `${value}`.replace(/\D/g, '');
    if (raw.length >= 6) return `${raw.slice(0, 4)}/${raw.slice(4, 6)}`;
    if (raw.length <= 2) {
        const month = Number(raw);
        if (month >= 1 && month <= 12) {
            const year = new Date().getFullYear();
            return `${year}/${String(month).padStart(2, '0')}`;
        }
    }
    return `${value}`;
}

function parseMonthToDate(value) {
    const normalized = normalizeMonthDisplay(value);
    if (!normalized) return new Date();
    const [year, month] = normalized.split('/').map((v) => Number(v));
    if (!year || !month) return new Date();
    return new Date(year, month - 1, 1);
}
</script>

<style lang="scss" scoped>
.date-input {
    border: 1px solid;
    text-align: center;
    padding: 5px 10px;
    max-width: 85px;
}
.line-date {
    width: 600px;
    column-gap: 30px;
}
</style>
